<template>
  <div class="page-container">
    <div class="query-title">生产计划汇总查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="汇总生产计划"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange1"
          @confirm="params => tableConfigConfirm(params, 'xTable')"
        >
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="params => rowClassName(params, 'xTable')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable')"
          >
            <template #PRODSUM_ID="{ row }">
              <span class="blue" @click="queryByCode(row)">{{ row.PRODSUM_ID }}</span>
            </template>
          </vxe-grid>
        </Table-filter>

        <Table-filter
          title="汇总计划项目"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions2.columns"
          :count-data="countFileds2"
          :all-options="allOptions2"
          :pagination="pagination2"
          @pagination-change="handleTablePaginationChange2"
          @confirm="params => tableConfigConfirm(params, 'xTable2')"
        >
          <vxe-grid
            ref="xTable2"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
            :row-class-name="params => rowClassName(params, 'xTable2')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable2')"
          />
        </Table-filter>

        <Table-filter
          title="生产计划"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions3.columns"
          :count-data="countFileds3"
          :all-options="allOptions3"
          :pagination="pagination3"
          @pagination-change="handleTablePaginationChange3"
          @confirm="params => tableConfigConfirm(params, 'xTable3')"
        >
          <vxe-grid
            ref="xTable3"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions3.columns"
            :data="gridOptions3.data"
            :row-class-name="params => rowClassName(params, 'xTable3')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable3')"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
  </div>
</template>

<script>
import { apiGetProdSumList } from '@/api/sap/make-plan'
import tableMixins from '@/utils/tableMixins'
import { pageSearch, config1, config2, config3 } from './config/makeSumQuery'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination3: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      gridOptions2: {
        columns: [],
        data: []
      },
      gridOptions3: {
        columns: [],
        data: []
      },
      pageSearch,
      searchField: {},
      // 第二个表格
      showHeader2: false,
      sortData2: [],
      tableconfigFilters2: {},
      condition2: {},
      calculation2: null,
      tableCountData2: [],
      filterList2: [],
      tableSort2: [],
      tableFilterData2: {},
      allOptions2: {},
      countFileds2: [],
      // 第三个表格
      showHeader3: false,
      sortData3: [],
      tableconfigFilters3: {},
      condition3: {},
      calculation3: null,
      tableCountData3: [],
      filterList3: [],
      tableSort3: [],
      tableFilterData3: {},
      allOptions3: {},
      countFileds3: []
    }
  },
  created() {
    this.searchField = this.pageSearch

    this.initPage(config1, 'gridOptions')
    this.initPage(config2, 'gridOptions2')
    this.initPage(config3, 'gridOptions3')
  },
  methods: {
    initPage(pageConfig, name = 'gridOptions') {
      const columns = []
      // const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120,
          filters: [],
          filterMultiple: false
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }
        columns.push(obj)

        // if (pageConfig[key].type) {
        //   searchField[key] = pageConfig[key]
        // }
      })

      // if (Object.keys(this.pageSearch).length) {
      //   Object.assign(this.pageSearch, searchField)
      //   this.searchField = this.pageSearch
      // } else {
      //   this.searchField = searchField
      // }

      this[name].columns = columns
    },
    showList(row) {
      this.$router.push({
        path: '/wly/make-plan/order-edit',
        query: {
          id: row.PRODPL_ID
        }
      })
    },
    queryByCode({ PRODSUM_ID }) {
      this.gridOptions1.data = this.gridOptions1.catchData.filter(v => v.PRODSUM_ID === PRODSUM_ID)
      this.gridOptions2.data = this.gridOptions2.catchData.filter(v => v.PRODSUM_ID === PRODSUM_ID)
    },
    async queryData(page, ranges) {
      // 分页
      if (page === 1) {
        this.pagination.page = page
        this.pagination2.page = page
        this.pagination3.page = page
        if (ranges) {
          this.ranges = ranges
          // this.handleRanges(ranges)
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        head: {
          ...this.pagination,
          ...this.condition,
          is_result: 1,
          sort: this.sortData.concat(this.tableSort)
        },
        itma: {
          ...this.pagination2,
          ...this.condition2,
          is_result: 1,
          sort: this.sortData2.concat(this.tableSort2)
        },
        itmb: {
          ...this.pagination3,
          ...this.condition3,
          is_result: 1,
          sort: this.sortData3.concat(this.tableSort3)
        },
        ...this.ranges
      }

      this.loading = true
      try {
        const { head, itma, itmb } = await apiGetProdSumList(params)
        if (
          (itma.data.length === 0 && (itma.total - 0)) ||
          (head.data.length === 0 && (head.total - 0)) ||
          (itmb.data.length === 0 && (itmb.total - 0))
        ) {
          this.queryData(1, ranges)
          return
        }
        // 分页
        this.pagination.totalCount = head.total - 0
        this.pagination2.totalCount = itma.total - 0
        this.pagination3.totalCount = itmb.total - 0
        // 第一个表格
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(head.data)
        } else {
          this.gridOptions.data = head.data.concat(this.tableCountData)
        }
        // 第二个表格
        if (this.showHeader2) {
          this.gridOptions2.data = this.tableCountData2.concat(itma.data)
        } else {
          this.gridOptions2.data = itma.data.concat(this.tableCountData2)
        }
        // 第三个表格
        if (this.showHeader3) {
          this.gridOptions3.data = this.tableCountData3.concat(itmb.data)
        } else {
          this.gridOptions3.data = itmb.data.concat(this.tableCountData3)
        }

        this.calculation = this.filtercalculation(head.calculation)
        this.calculation2 = this.filtercalculation(itma.calculation, 'xTable2')
        this.calculation3 = this.filtercalculation(itmb.calculation, 'xTable3')
        // 更新计算值
        this.updateCount()
        this.updateCount('xTable2')
        this.updateCount('xTable3')

        // 筛选条件
        this.allOptions = this.filterAllOptions(head.field)
        this.allOptions2 = this.filterAllOptions(itma.field, 'xTable2')
        this.allOptions3 = this.filterAllOptions(itmb.field, 'xTable3')
        this.setFilter()
        this.setFilter('xTable2')
        this.setFilter('xTable3')
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange1(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    handleTablePaginationChange2(pages) {
      Object.assign(this.pagination2, pages)
      this.queryData()
    },
    handleTablePaginationChange3(pages) {
      Object.assign(this.pagination3, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/makeSumQuery.vue